import React from 'react'
import { Container } from 'reactstrap';
import ImportClientData from '../components/Import/ImportClientData';
import ImportCustomerRevenue from '../components/Import/ImportCustomerRevenue';
import ImportReconReports from '../components/Import/ImportReconReports';
import ImportLogFiles from '../components/Import/ImportLogFiles';
import ImportTimeRevWorksheet from '../components/Import/ImportTimeRevWorksheet';
import CollapseCard from '../components/CollapseCard/CollapseCard';
import 'bootstrap/dist/css/bootstrap.css';

class Import extends React.Component {

    componentDidMount = () => {
        this.props.log('Import.js/componentDidMount');
    }

    render = () => {
        this.props.info('Import.js/render');
        return (
            <>
                <Container>
                    <CollapseCard title="Client Data" open={false}>
                        <ImportClientData {...this.props} />
                    </CollapseCard>
                    <CollapseCard title="Customer Revenue" open={false}>
                        <ImportCustomerRevenue {...this.props} />
                    </CollapseCard>
                    <CollapseCard title="Log Files" open={false}>
                        <ImportLogFiles {...this.props} />
                    </CollapseCard>
                    <CollapseCard title="Recon Reports" open={false}>
                        <ImportReconReports {...this.props} />
                    </CollapseCard>
                    <CollapseCard title="Time Worksheets" open={true}>
                        <ImportTimeRevWorksheet {...this.props} />
                    </CollapseCard>
                </Container>
            </>
        )
    }
}

export default Import;